import * as React from 'react';

import {
    IBuyboxCommonData,
    IBuyboxExtentedProps,
    IProductDetails
} from '@msdyn365-commerce-modules/buybox/src/common/buyboxInterface';

import { Heading } from '@msdyn365-commerce-modules/utilities';


export function getBuyboxProductDescriptionFormat(
    props: IBuyboxExtentedProps<IBuyboxCommonData>,
    productDetails?: IProductDetails
): React.ReactElement | undefined {
    const { typeName } = props;
    const className = _getClassNamePrefix(typeName);

    // Since the data action can return no value, and the type is non-nullable due to backward compatibility reasons, the null check is required.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Explicitly check for null/undefined.
    const product = props.data.product?.result ?? productDetails?.product ?? undefined;

    return product && <p className={`${className}__product-description`}
        style={{ whiteSpace: 'pre-wrap' }}>{product.Description}</p>;
}

// TODO: check if itemId is needed, remove if it is not needed and use the buybox-component logic instead
export function getBuyboxProductTitleWithItem(
    props: IBuyboxExtentedProps<IBuyboxCommonData>,
    productDetails?: IProductDetails
): React.ReactElement | undefined {
    const {
        config: { titleHeadingTag = 'h1' },
        typeName
    } = props;
    const className = _getClassNamePrefix(typeName);

    // Since the data action can return no value, and the type is non-nullable due to backward compatibility reasons, the null check is required.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Explicitly check for null/undefined.
    const product = props.data.product?.result ?? productDetails?.product ?? undefined;

    return product && (
        <Heading
            className={`${className}__product-title`}
            headingTag={titleHeadingTag}
            text={`${product.ItemId ?? ''}\n${product.Name ?? ''}`}
        />
    );
}

const _getClassNamePrefix = (typeName: string): string => {
    return typeName.toLocaleLowerCase() === 'quickview' ? 'ms-quickView' : 'ms-buybox';
};
